'use client';

import {useReportWebVitals} from 'next/web-vitals';

export default function WebVitals() {
  /* Sites that pass the Core Web Vitals test have a higher chance of making it 
   to Google's first page than sites offering poor user experience and higher page loading times.
   https://web.dev/explore/metrics

  Largest Contentful Paint (LCP)
  Cumulative Layout Shift (CLS)
  Interaction to Next Paint (INP)
  Time to First Byte (TTFB)
  First Contentful Paint (FCP)
  Total Blocking Time (TBT)
  */
  useReportWebVitals((metric) => {
    console.log(metric);
  });
  return <></>;
}
